<div class="dialog-container">
  <div mat-dialog-title>
    {{ 'Contacts.Management.Groups.Select' | translate: locale.language }}
    @if (!data?.hideClassification) {
      <small style="float: right">
        <mat-button-toggle-group name="classification" [formControl]="classification">
          <mat-button-toggle value="All">
            {{ 'Contacts.Management.Groups.All' | translate: locale.language }}
          </mat-button-toggle>
          <mat-button-toggle value="Internal">
            {{ 'Contacts.Management.Groups.Internal' | translate: locale.language }}
          </mat-button-toggle>
          <mat-button-toggle value="Public">
            {{ 'Contacts.Management.Groups.Public' | translate: locale.language }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </small>
    }
    <div class="flex-row" style="font-size: 14px; margin-top: 1rem">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>{{ 'Contacts.Management.Groups.Search' | translate: locale.language }}</mat-label>
        <input matInput [formControl]="searchControl" />
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-content>
    <app-loading
      [hasLoaded]="!isLoading"
      [hasFailed]="hasLoadError"
      [alignCenter]="true"
      [diameter]="100"
      (retryClicked)="getParentGroups()"
      [isInline]="true"
      style="margin: auto"></app-loading>

    @if (!isLoading && !hasLoadError) {
      <div class="flex-row">
        <div class="flex-col" style="border-right: 1px solid lightgray; margin: 0 1rem">
          <div class="available-groups-container">
            <div class="flex-row" style="justify-content: center">
              <p>
                <strong>{{ 'Contacts.Management.Groups.Available' | translate: locale.language }}</strong>
              </p>
            </div>
            @if (!topLevelGroups[classification.value]?.length) {
              <span>
                {{ 'Contacts.Management.Groups.NoAvailableGroups' | translate: locale.language }}
              </span>
            }
            <div class="available-groups">
              @for (parentGroup of topLevelGroups[classification.value]; track parentGroup.group.id) {
                <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: parentGroup }"></ng-container>
              }
            </div>
          </div>
        </div>
        <div class="flex-col" style="margin: 0 1rem">
          <div class="selected-groups-container">
            <div class="flex-row" style="justify-content: center">
              <p>
                <strong>{{ 'Contacts.Management.Groups.Selected' | translate: locale.language }}</strong>
              </p>
            </div>
            <mat-chip-set class="selected-groups-chip-list">
              @if (!selectedGroupNodes?.length) {
                <mat-chip disabled>
                  {{ 'Contacts.Management.Groups.NoGroupsSelected' | translate: locale.language }}
                </mat-chip>
              }
              @for (node of selectedGroupNodes; track node.group.id) {
                <mat-chip [removable]="true" (removed)="onRemoveGroup(node)">
                  {{ node.group.name }}
                  <button matChipRemove [attr.aria-label]="'Remove ' + node.group.name" [tabIndex]="0">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      </div>
    }

    <ng-template #groupTemplate let-node>
      <div class="flex-row">
        <div class="flex-col">
          <div class="flex-row" style="align-items: center">
            @if (hasChildren(node.group) && !canAssignToParentGroups) {
              <mat-icon style="color: #757575; margin-left: 0.2rem; margin-right: 0.2rem"> folder </mat-icon>
            }
            @if (!hasChildren(node.group) || canAssignToParentGroups) {
              <mat-checkbox
                [checked]="isGroupSelected(node.group)"
                (change)="onToggleGroup(node)"
                [aria-labelledby]="node.group.id + '-label'">
              </mat-checkbox>
            }
            <button
              [disabled]="hasChildren(node.group) && !canAssignToParentGroups"
              mat-button
              color="primary"
              (click)="onToggleGroup(node)"
              style="justify-content: left"
              [id]="node.group.id + '-label'">
              {{ node.group.name }}
            </button>
            @if (hasChildren(node.group)) {
              <button
                mat-icon-button
                (click)="onExpandNode(node)"
                [attr.aria-label]="(node.expanded ? 'Collapse ' : 'Expand ') + node.group.name">
                <mat-icon>{{ node.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            }
            @if (node.loading) {
              <mat-progress-bar mode="indeterminate" style="width: 50px"></mat-progress-bar>
            }
            @if (node.group.isLink) {
              <mat-icon style="color: #757575">link</mat-icon>
            }
          </div>
          @if (node.expanded) {
            @for (child of getChildren(node); track child.group.id) {
              <div class="flex-row" [style.margin-left]="getIndentLevel(child)">
                <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: child }"></ng-container>
              </div>
            }
          }
        </div>
      </div>
    </ng-template>
  </div>

  <div mat-dialog-actions style="justify-content: flex-end">
    <button mat-button [mat-dialog-close]="null">
      {{ 'Cancel' | translate: locale.language }}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="selectedGroups">
      {{ 'Save' | translate: locale.language }}
    </button>
  </div>
</div>
